import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {PaymentMethodsListHeader} from './components/header/PaymentMethodsListHeader'
import {PaymentMethodsTable} from './table/PaymentMethodsTable'
import { PaymentMethodEditModal } from './PaymentMethod-edit-modal/PaymentMethodEditModal'
import {KTCard} from '../../../../_metronic/helpers'

const PaymentMethodsList = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard>
        <PaymentMethodsListHeader />
        <PaymentMethodsTable />
      </KTCard>
      {itemIdForUpdate !== undefined && <PaymentMethodEditModal />}
    </>
  )
}

const PaymentMethodsListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <PaymentMethodsList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {PaymentMethodsListWrapper}
